import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  toggler: {
    width: '100%',
  },
}));
